import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchStarredBoards } from '../../redux/Slices/boardsSlice';
import { setLoading } from '../../redux/Slices/boardSlice';
import { closeExpandableColumn } from '../../redux/Slices/expandableColumnSlice';
import Spinner from '../Global/Spinner';
import StarFill from '../icons/StarFill';
import './StarredColumn.scss';

const StarredColumn = ({ boardId }) => {
    const dispatch = useDispatch();
    const { starredBoards, starredStatus } = useSelector((state) => state.boards);

    useEffect(() => {
        // Only fetch if status is idle (not loading, not already succeeded)
        if (starredStatus === 'idle') {
            dispatch(fetchStarredBoards({ useCache: true }));
        }
    }, [starredStatus, dispatch]);

    const handleBoardLink = () => {
        dispatch(setLoading(true));
        dispatch(closeExpandableColumn());
    }

    return (
        <div className='starred-column'>
            <div className="starred-column__content">
                {starredStatus === 'loading' ? (
                    <div className="loading-container">
                        <Spinner size={30} color="#3498db" speed={1.5} />
                    </div>
                ) : starredBoards?.length > 0 ? (
                    <div className="starred-list">
                        {starredBoards.map(board => (
                            <div
                                className={`starred-item${boardId === board?.shortId ? ' active' : ''}`}
                                key={board._id}
                            >
                                <div className="starred-avatar">
                                    {board.cover?.sizes?.thumbnail ? (
                                        <div
                                            className="board-cover"
                                            style={{ backgroundImage: `url('${board.cover?.sizes?.medium}')` }}
                                        >
                                            <StarFill color={'#FFD700'} size={14} />
                                        </div>
                                    ) : (
                                        <div className="board-placeholder">
                                            <StarFill color={'#FFD700'} size={14} />
                                        </div>
                                    )}
                                </div>

                                <div className="starred-content">
                                    <div className="starred-text">
                                        <strong>{board.title}</strong>
                                    </div>
                                    {/* <div className="starred-subtitle">{board.workspace.name}</div> */}
                                </div>

                                {boardId !== board?.shortId && (
                                    <Link
                                        onClick={handleBoardLink}
                                        className="starred-link"
                                        to={board.permalink}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="empty-state">
                        <div className="empty-icon">
                            <StarFill color={'var(--secondary-text-color)'} size={48} />
                        </div>
                        <h3>No starred boards</h3>
                        <p>Star boards to see them here for quick access.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StarredColumn;
